import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import AxiosApiClient from '../../components/utils/AxiosApiClient';
import AuthUtility from '../../components/frontend/auth/AuthUtility';

import swal from 'sweetalert';

import home_icon from '../../assets/frontend/images/home_icon.png';
import plans_icon from '../../assets/frontend/images/plans_icon.png';
import users_icon from '../../assets/frontend/images/users_icon.png';
import schedule_icon from '../../assets/frontend/images/schedule_icon.png';
import account_icon from '../../assets/frontend/images/account_icon.png';

const StickyBottomAdminNav = () => {

	//logout should be its own component
	const navHistory = useNavigate();

	//for all API calls
	const auth_api = 'phpLaravel';
	if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
		auth_api = localStorage.getItem('auth_api');
	}

	// using hooks
	const [isLoading, setIsLoading] = useState(false);

	const LogoutService = (event) => {
		event.preventDefault();

		setIsLoading(true);

		const fetchApiData = async () => {
			try {
				const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
				await getBearerToken();
				const response = await makeRequestWithHeaders('get', '/api/logout', null, {});

				setApiData(response, "LogoutService");
			} catch (error) {
				handleApiError(error, "LogoutService");
			}
		};

		fetchApiData();
	}
	function setApiData(response, theFunction) {
		if (response && response.data) {
			if (response.data.status === 200) {//HTTP_OK
				console.log(theFunction + ': ', response.data.message);

				//user not authenticated on server so remove from local storage
				AuthUtility.clearAuthData();

				//redirect to home page
				navHistory('/');

			} else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				//user not authenticated on server so remove from local storage
				AuthUtility.clearAuthData();

				swal("Warning", response.data.message, "warning");

				navHistory('/login');

			} else {//more errors
			}
		}

		setIsLoading(false);
	}
	function handleApiError(error, theFunction) {
		console.log(theFunction + ' error: ', error + ' back-end api call error');

		//user not authenticated on server so remove from local storage
		AuthUtility.clearAuthData();
		setIsLoading(false);
		swal("Error", error, "error");
		navHistory('/login');
	}

	return (
		<div className="sticky-bottom z-index-1010">
			<div className="sticky bg-fafafa bt1-ddd plr-20l-10sz ptb-10l-5s">

				<div className="panel large">
					<div className="horizontal-container center">

						<div className="element mlr-20l-10m">
							<Link to="/home" className="button icon-sticky-bottom image-container no-underline">
								<div className="hide-for-small-only">
									<img src={home_icon} alt="add icon" width="40" className="pb-5" />
									<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Home</div>
								</div>
								<div className="show-for-small-only">
									<div className="hide-for-520px">
										<img src={home_icon} alt="add icon" width="33" className="pb-5" />
										<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Home</div>
									</div>
									<div className="show-for-520px">
										<img src={home_icon} alt="add icon" width="25" className="pb-5" />
										<div className="font-source-sans font-size-11 font-weight-600 letter-spacing-0px uppercase">Home</div>
									</div>
								</div>
							</Link>
						</div>
						<div className="element mlr-20l-10m">
							<Link to="/admin/plans" className="button icon-sticky-bottom image-container no-underline">
								<div className="hide-for-small-only">
									<img src={plans_icon} alt="plans_icon" width="40" className="pb-5" />
									<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Plans</div>
								</div>
								<div className="show-for-small-only">
									<div className="hide-for-520px">
										<img src={plans_icon} alt="plans_icon" width="33" className="pb-5" />
										<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Plans</div>
									</div>
									<div className="show-for-520px">
										<img src={plans_icon} alt="plans_icon" width="25" className="pb-5" />
										<div className="font-source-sans font-size-11 font-weight-600 letter-spacing-0px uppercase">Plans</div>
									</div>
								</div>
							</Link>
						</div>
						<div className="element mlr-20l-10m">
							<Link to="/member/users" className="button icon-sticky-bottom image-container no-underline">
								<div className="hide-for-small-only">
									<img src={users_icon} alt="users_icon" width="40" className="pb-5" />
									<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Users</div>
								</div>
								<div className="show-for-small-only">
									<div className="hide-for-520px">
										<img src={users_icon} alt="users_icon" width="33" className="pb-5" />
										<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Users</div>
									</div>
									<div className="show-for-520px">
										<img src={users_icon} alt="users_icon" width="25" className="pb-5" />
										<div className="font-source-sans font-size-11 font-weight-600 letter-spacing-0px uppercase">Users</div>
									</div>
								</div>
							</Link>
						</div>
						<div className="element mlr-20l-10m">
							<Link to="/member/subscriptions" className="button icon-sticky-bottom image-container no-underline">
								<div className="hide-for-small-only">
									<img src={schedule_icon} alt="schedule_icon" width="40" className="pb-5" />
									<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Subs</div>
								</div>
								<div className="show-for-small-only">
									<div className="hide-for-520px">
										<img src={schedule_icon} alt="schedule_icon" width="33" className="pb-5" />
										<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Subs</div>
									</div>
									<div className="show-for-520px">
										<img src={schedule_icon} alt="schedule_icon" width="25" className="pb-5" />
										<div className="font-source-sans font-size-11 font-weight-600 letter-spacing-0px uppercase">Subs</div>
									</div>
								</div>
							</Link>
						</div>
						<div className="element mlr-20l-10m">
							<Link to="/member/account" className="button icon-sticky-bottom image-container no-underline">
								<div className="hide-for-small-only">
									<img src={account_icon} alt="account_icon" width="40" className="pb-5" />
									<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Account</div>
								</div>
								<div className="show-for-small-only">
									<div className="hide-for-520px">
										<img src={account_icon} alt="account_icon" width="33" className="pb-5" />
										<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Acct</div>
									</div>
									<div className="show-for-520px">
										<img src={account_icon} alt="account_icon" width="25" className="pb-5" />
										<div className="font-source-sans font-size-11 font-weight-600 letter-spacing-0px uppercase">Acct</div>
									</div>
								</div>
							</Link>
						</div>

					</div>
				</div>

			</div>
		</div>
	);
}

export default StickyBottomAdminNav;